import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import SearchBar from './SearchBar';
import youtube from '../apis/YOUTUBE';
import firebase from './firebase';
import VideoList from './VideoList';
import VideoDetail from './VideoDetail';
import Coverflow from 'react-coverflow';
import $ from 'jquery';
import './backgrd.css';
import {Launcher} from 'react-chat-window';
import { Chat } from 'react-chat-popup';
import rote from '../images/rote.jpg';
import Spiner from '../spinner';
import channels from '../images/channels.JPG';
import omoape from '../images/omaope.JPG';
import osiomole from '../images/osiomole.JPG';
import channBack from '../images/channbackground.JPG';
import chanMan01 from '../images/chanMan01.JPG';
import channel02 from '../images/channels02.JPG';
import sunrise from '../images/sunrise.JPG';
import { async } from 'q';
import Form from './ChatForm/Form.js';
import Sidebar from './SideBar';
import './SideBar/style.css'


const YouTube='https://www.googleapis.com/youtube/v3/search';
const fn = function () {
    /* do your action */
  }
class App extends Component {
    state={videos:[],
      selectedVideo:null,
      lat:'', longitude:null,
      errorMessage:'',     
      location:[],
      user:null,      
        
    }
    componentDidMount(){
        this.onTermSubmit("buildings");
        this.onLoadVideo('fdfffddf');
        this.getLocation();         
        firebase.auth().onAuthStateChanged(user => {
          this.setState({ user });
        });
      
    }
    
    
    getLocation=()=>{
      window.navigator.geolocation.getCurrentPosition(
        position=>
            this.setState({lat:position.coords.latitude})
             ,               
        err=> 
            this.setState({errorMessage:err.message}),       
    )
   
    } 
        onTermSubmit= async (term)=>{
//console.log(term);
 const response=await youtube.get('/search',{
    params:{
     q: term
     
 }
 });

this.setState({
    videos:response.data.items,
    selectedVideo:response.data.items[0]
})
    }
   
    onLoadVideo = async(term) => {
     
       let userdata=[];   
   //firebase.database().ref('front-mediaPay').orderByChild(term).limitToLast(8)
  await firebase.database().ref('front-mediaPay').orderByChild(term)
   .on("value", (snapshot=>{   
    var userdata = snapshot.val();
    let newProducts=[];
    const keys = Object.keys(userdata);
for (let i = 0; i < keys.length; i++) { //loop thru all data from firebase
const k = keys[i];
newProducts.push({                //save all data to a new array
   EntryDate:userdata[k].EntryDate,
   title:userdata[k].title,
   username:userdata[k].username,
   videoID:userdata[k].videoID,
   url:userdata[k].url,
   urlCover:userdata[k].urlCover,
   messages:userdata[k].messages,  
   
  });
  this.setState({videos: newProducts});          //using Object entries
this.setState({selectedVideo:newProducts[0]});
}
}))  
}
    onVideoSelect=(video)=>{
this.setState({selectedVideo:video})
const itemsRef =firebase.database().ref('location');
const data={
  mylocation:this.state.lat,
  mylat:this.state.errorMessage
}
itemsRef.push(data);
    }
    //chat
handleNewUserMessage = (chat) => {
 
const itemsRef =firebase.database().ref('chat');
  const data={
    chat:chat,
    location:this.state.lat
    
  }
  itemsRef.push(data);
}

//when user clicks signIn, then, component will receive the props

//SignIn event
handleSignIn=() =>{
  const provider = new firebase.auth.GoogleAuthProvider();
  firebase.auth().signInWithPopup(provider);
}
doCreateUserWithEmailAndPassword = (email, password) =>{
const provider = new firebase.auth.createUserWithEmailAndPassword(email, password);
}
//Logout event
handleLogOut=()=> {
  firebase.auth().signOut();
}
//This area is for chat
  
    render () {    
      // console.log(this.state.selectedVideo);
      if(this.state.videos && this.state.selectedVideo){
      
           
      return(
        
       
              <div className="Halfbody black">              
              <div className="ui secondary  menu">
              <Sidebar/> 
 
 
  
  <div className="center menu">
    <div className="item">
    
    </div>
    { !this.state.user ? (   
      
<i className="user icon"
      onClick={this.handleSignIn.bind(this)}
      > <br/> <span style={{color:'#DE5C1F', fontSize:'14px',margin:'8px'}}><br style={{margin:'4px'}}/>Login</span> 
      </i>          
            
          ) : (
            
            <i className="times circle icon"   onClick={this.handleLogOut.bind(this)}><br/>
            <span style={{color:'#DE5C1F', fontSize:'14px',margin:'8px'}}>Logout</span> 
              </i>
          )}
  </div>
</div>
            
<h2 className=" center aligned  ui header ">
  <img src={channels} className="ui circular image btn btn-white logo b-animated "/>
  
</h2>


            <div className="  ui container">
            
                <SearchBar onFormSubmit={this.onTermSubmit} />
                <div className="ui grid">
                
                    <div className="ui row">
                        <div className="eleven wide column">
                               
                <VideoDetail video={this.state.selectedVideo} user={this.state.user} onVideoSelect={this.onVideoSelect}   />           
               
                <div className="four wide column">
                
                 <Form  message={this.state.selectedVideo} user={this.state.user}/> 
                </div>
              
                </div>
                <div className="five wide column">
                <VideoList onVideoSelect={this.onVideoSelect} videos={this.state.videos}/>
                </div>
               
                </div>
               
                </div>
               
            </div>
          

            <Coverflow width="960" height="500" 
    displayQuantityOfSide={2}
    navigation={false}
    enableScroll={true}
    clickable={true}
    active={0}
    infiniteScroll={true}
  >
    <div
      onClick={() => fn()}
      onKeyDown={() => fn()}
      role="menuitem"
      tabIndex="0"
    >
      <img
        src={sunrise}
        
        style={{
          display: 'block',
          width: '100%',
        }}
      />
    </div>
   <span className="btn btn-white btn-animated "> <img src={omoape}  /></span>
   <span className="btn btn-white btn-animated "> <img  src='https://images.pond5.com/camera-lens-front-sight-close-psd-075391330_iconl1.jpeg'  /></span>
  
   <span className="btn btn-white btn-animated "> <img  src='https://images.pond5.com/old-8mm-camera-photo-012482316_iconl.jpeg'  /></span>
 
    <img  src="https://i1.wp.com/media.premiumtimesng.com/wp-content/files/2017/05/NAtional-Assembly-2.jpg?fit=860%2C484&ssl=1"  />
    <img  src="https://buzznigeria.com/wp-content/uploads/2015/03/olumorock.jpg"  />
    <img  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0abelVHCg6-GF-tvo_isd48yp2YU-BAClXI_CZ7uNK1ehv1jv"  />
    <img  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSiUJZheoFgCZ3iErD_NetgYD-5jaVgB5VpyKS75XjsWpWfUxNY"  /> 
    
  </Coverflow>
  <div class="bblack sixteen wide column">
    <center><small className="ui bblack circular label">6 Broad street, Marina Lagos</small></center>
    <center><a className="ui black circular label btn btn-white btn-animated ">InthyMedia Inc</a><span>
   
    <small className="ui black circular label btn btn-white btn-animated ">Head Office:83/121 Thynne street Bruce,2617, Australia</small></span></center><br/>
    </div>
   
  <Chat
          handleNewUserMessage={this.handleNewUserMessage}
        />
            
        </div>
       
      
      )
    }
     
     else
     return(   
      <Spiner message="Loading movie..." />
                  )
         
    } 
}
        
export default App


